export const bgShadowMap = new Map<string, string>([
  ['#E9CBBE', '#DA9A7F'],
  ['#F3E4BD', '#DEC689'],
  ['#DDDDDD', '#BCBCBC'],
  ['#BEEACF', '#87DCA8'],
  ['#EDC1D1', '#DE86A6'],
  ['#ECC4D9', '#DD80B2'],
  ['#D4EAB9', '#B0D97E'],
  ['#EFEEC0', '#DDDB87'],
  ['#CBF3F1', '#92D9D5'],
  ['#F2C1E6', '#E0A1D1'],
  ['#C3EEC2', '#9DDA9B'],
  ['#DBCCEE', '#B08DDD'],
  ['#8E8E8E', '#6B6B6B'],
  ['#EFD4BF', '#D7AB89'],
  ['#C3CDEF', '#8698D5'],
  ['#D5BFF3', '#BA9CE2'],
  ['#55BEAC', '#55BEAC'],
  ['#D56845', '#F4BBAB'],
  ['#9677A3', '#9677A3'],
  ['#FFCAAA', '#FFCAAA'],
  ['#93DEEA', '#93DEEA'],
]);
